module.exports = __webpack_public_path__ + "img/BK_BODEGA_AURRERA.3bb46007.png";